
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offline",
      function () {
        return require("private-next-pages/offline.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offline"])
      });
    }
  